module.exports = __webpack_public_path__ + "files/5a7c131ecba69871990fd45f4441838b.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/arvo-bolditalic-webfont.svg
 ** module id = 886
 ** module chunks = 0
 **/